<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.5 6.53554L8.03553 10.0711L11.5711 6.53554" stroke="currentColor" stroke-linecap="round"/>
</svg>
